<template>
  <Tooltip trigger="control" :aria-label="t('components.form.fieldHelp', { label })" :focusable="true" :text="text">
    <CircleHelpIcon class="h-4 w-4 text-muted-foreground" aria-hidden="true" />
  </Tooltip>
</template>

<script setup lang="ts">
// What a field is for, behind an icon beside its label. Under the control is
// kept for the value's format and limits, the hint, the warning and the error.
// A row drawn without FieldRow (a file button, a checklist) puts this after its
// label so every field explains itself the same way.
import { CircleHelpIcon } from "lucide-vue-next";

import Tooltip from "@/components/kit/Tooltip.vue";
import { useStrongTypedI18n } from "@/i18n/useStrongTypedI18n";

defineProps<{ label: string; text: string }>();

const { t } = useStrongTypedI18n();
</script>
